export default __webpack_public_path__ + "img/sinceh5.cc731b92.svg";